import React from 'react';

export const host = 'https://52.47.47.152'
export const APIHostContext = React.createContext();